/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-completed-deliveries-view-component.ts
 *
 * Created by randysorensen on 2/19/18.
 */

function PackageCompletedDeliveriesViewController(
    this: JS5Object,

    // external dependencies
    _: JS5Object,

    // internal dependencies
    PackageUtilService: JS5Object
) {

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$postLink = () => {
        PackageUtilService.editorForm = this.packageCompletedDeliveriesEditorForm;
    };

}

angular
    .module('prism-ui.package')
    .component('packageCompletedDeliveriesView', {
        controller:PackageCompletedDeliveriesViewController,
        templateUrl: 'package/editor/components/view/completedDeliveries/package-completed-deliveries-view-template.html',
        bindings: {
            packageObject: '=',
            loadingIndicator: '=',
            pkgEditCtrl: '=',
        }
    });

// (EOF)
